import React from "react";

export function ResetConfirmation({ back, confirm }) {
  return (
    <div className="intervention">
      <div className="modal">
        <div className="message">Are you sure you want to reset this box?</div>
        <div className="buttons">
          <button
            onClick={back}
            className="secondary"
          >
            No!!! Go back!!!
          </button>
          <button
            onClick={confirm}
            className="main"
          >
            Yes, reset it
          </button>
        </div>
      </div>
    </div>
  );
}
